module.exports = __webpack_public_path__ + "img/logo.f660bfb3.png";